import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Box, List, ListItem, Typography, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { UpdateAccounting } from 'components/Modals/PromoCodes';
import { Card } from 'components/UI';
import i18n from 'i18n-js';
import { PricingActions } from 'state/modules/pricing';

const PromoCodeAccounting = ({ id, promoCode }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [openAccountingModal, setOpenAccountingModal] = useState(false);
  const { adhoc } = useSelector((state) => state.pricing);

  useEffect(() => {
    if (id) {
      dispatch(PricingActions.fetchAdHocTypesById(id));
    }
  }, [id, dispatch]);

  const handleOpenEditAccountingModal = () => {
    setOpenAccountingModal((prevState) => !prevState);
  };
  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [
    {
      title: i18n.t('promo_codes.edit_accounting'),
      onClick: handleOpenEditAccountingModal,
    },
  ];

  const listStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
    paddingTop: 0,
    marginTop: -5,
    alignItems: 'flex-start',
  };

  const itemStyles = {
    padding: '0 4px 8px 0',
    '&:not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.common.greyLight}`,
    },
  };

  const itemTextStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiListItemText-primary': {
      color: theme.palette.text.subtitle,
      fontSize: '13px',
      fontWeight: 500,
      wordBreak: 'break-word',
    },
    '& .MuiListItemText-secondary': {
      color: theme.palette.common.lightNavy,
      fontSize: '13px',
      wordBreak: 'break-word',
    },
  };

  return (
    <Card
      menuItems={items}
      menuPermissions={{
        action: 'update',
        subject: 'promotional_code',
        type: 'can',
      }}
      title={i18n.t('promo_codes.accounting')}
      headerActionType="vertical"
    >
      <Box sx={{ padding: '24px 0 0' }}>
        <List sx={listStyles}>
          <ListItem sx={itemStyles}>
            <ListItemText
              sx={itemTextStyles}
              primary={`${i18n.t(`promo_codes.credit_type`)}:`}
              secondary={
                <Box
                  display="flex"
                  component="span"
                  flexDirection="column"
                  sx={{ textAlign: 'right' }}
                >
                  <Typography variant="body2" component="span" color="textSecondary">
                    {adhoc?.name}
                  </Typography>
                </Box>
              }
            />
          </ListItem>
        </List>
      </Box>
      {openAccountingModal && (
        <UpdateAccounting
          id={id}
          promoCode={promoCode}
          open={openAccountingModal}
          handleClick={handleOpenEditAccountingModal}
        />
      )}
    </Card>
  );
};

PromoCodeAccounting.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  promoCode: PropTypes.object,
};

export default PromoCodeAccounting;
